import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {WeightTrackingDependencies} from '../dependencies';
import type {WeightSeriesRange} from '../application/ports/weight-tracking.repository';
import {keys} from './keys';

export type GetWeightSeriesQueryDependencies = Pick<WeightTrackingDependencies, 'controllers'>;

export const getWeightSeriesQuery = (
  {controllers}: GetWeightSeriesQueryDependencies,
  range: WeightSeriesRange,
) =>
  queryOptions({
    queryKey: keys.series(range),
    queryFn: () => controllers.weightTrackingController.series(range).then(unwrap),
  });
